import React from 'react'
import "./About.css"
import { Link } from 'react-router-dom'
import image1 from './images/galleryimgs/a.png'
import image2 from './images/galleryimgs/b.png'
import image3 from './images/galleryimgs/c.png'
import image5 from './images/galleryimgs/e.png'
import Trainer from './Trainer'

const About = () => {
  return (
    <div className="about">
      <div className="about_top">
        <div className="about__top">
          <p className='about__top_p'>ABOUT ACADEMY</p>
          <div className="about__top__btn-group">
            <Link to="/" className='about__top_btn'>Home </Link>
            <span>&nbsp;/&nbsp;</span>
            <p className='about__top_a'>About</p>
          </div>
        </div>
      </div>
      <div className="about_top1">
        <div className="about_top1-left">
          <div className="about-heading-1">Know us</div>
          <p className='about_heading_top'>More than just a MMA academy</p>
          <p className='about_para'><span>Mutant MMA Academy</span> in Dehradun, Uttarakhand is the premier destination for mixed martial arts training.
            <br></br><br></br> Our distinguished academy boasts the largest number of professional fighters in the state, with aspiring fighters from across the country training with us.
            <br></br><br></br>We offer a comprehensive fitness program for those who want to learn MMA but do not wish to pursue a professional career.
            <br></br><br></br>Our world-class trainers, including some of the best fighters in the country, provide an inclusive environment for people of all ages and genders to learn self-defense, improve their fitness, or pursue their dreams of becoming a professional fighter.<br></br><br></br>Join us and become part of the Mutant MMA community.</p>
        </div>
        <div className="about_top1-right">
          <ImageGallery />
        </div>

      </div>
      <div className="about-trainer">
        <Trainer />
      </div>
    </div >
  )
}

export const ImageGallery = () => {
  const images = [image1, image2, image3, image5];
  return (
    <div className="image-gallery">
      {images.map((image, index) => (
        <img key={index} src={image} alt={`${index + 1}`} className='about-gallery-img' />
      ))}
    </div>
  );
};

export default About